module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticketTypes != undefined && _vm.ticketTypes.length > 0) ? _c('sk-form', {
    staticClass: "loyalty",
    attrs: {
      "inline": ""
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h2', [_vm._v("Add Movie cards and vouchers")]), _vm._v(" "), _c('p', [_vm._v("Do you have an SK Club, Discovery Vitality or Edgars Club Movie Card?")]), _vm._v(" "), (_vm.newCard.TicketType != null) ? [(_vm.newCard.TicketType.Description.includes('Edgars') || _vm.newCard.TicketType.Description.includes('Primedia') || _vm.newCard.TicketType.Description.includes('Employee') || _vm.newCard.TicketType.Description.includes('Premier')) ? _c('p', [_vm._v("Capture your card details and add to order a ticket. Repeat step for 2 tickets.")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: " loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.availableLoyalties.length > 0 && _vm.user.CardNumber) ? [_c('p', [_vm._v("Choose your linked cards")]), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.availableLoyalties), function(card, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "sm12": "",
        "md7": "",
        "lg4": ""
      }
    }, [_c('sk-checkbox', {
      staticClass: "linked-card",
      attrs: {
        "name": 'radio-gender-' + index,
        "label": "I'd rather not say"
      },
      on: {
        "input": function($event) {
          _vm.toggleLoyalty(card)
        }
      },
      model: {
        value: (card.linked),
        callback: function($$v) {
          _vm.$set(card, "linked", $$v)
        },
        expression: "card.linked"
      }
    }, [_c('div', {
      staticClass: "linked-card__description",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/loyalty-sk-club.png",
        "alt": "Sk Club"
      }
    })] : [(card.TicketType.Description.includes('SK MORvies')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/morvies_club_card.png",
        "alt": "Sk Club"
      }
    })] : [(card.TicketType.Description.includes('SK Fan')) ? [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": "/static/img/fan_club_card.png",
        "alt": "Sk Club"
      }
    })] : _vm._e()]], _vm._v(" "), _c('div', {
      staticClass: "linked-card__card-content"
    }, [_c('div', {
      staticClass: "linked-card__club-cards-title"
    }, [_vm._v("\n                                        " + _vm._s(card.TicketType.Description) + "\n                                    ")]), _vm._v(" "), _c('p', {
      staticClass: "linked-card__club-cards-copy"
    }, [_vm._v("\n                                        " + _vm._s(card.CardNumber) + "\n                                    ")])])], 2)])], 1)
  })), _vm._v(" "), _c('br')], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loyalty-card-add"
  }, [(_vm.ticketTypes.length > 0) ? _c('div', {
    staticClass: "form-group loyalty-card__movie-card"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Add Movie Card Number or Voucher Code")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketTypes,
      "track-by": "TicketTypeCode",
      "label": "Description",
      "placeholder": "Choose Card or Voucher",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "preLabel",
      fn: function(internalValue) {
        return [(internalValue.option[0].length === undefined) ? _c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": _vm.getLoyalty(internalValue.option[0])
          }
        })]) : _vm._e()]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [(props) ? _c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": _vm.getLoyalty(props.option)
          }
        })]) : _vm._e(), _vm._v("\n                                    " + _vm._s(props.option.Description) + "\n                                ")])]
      }
    }]),
    model: {
      value: (_vm.newCard.TicketType),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "TicketType", $$v)
      },
      expression: "newCard.TicketType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isStandardPackageTicket) ? [_c('sk-input', {
    class: _vm.$breakpoints.smDown ? '' : 'loyalty-card__no-label',
    attrs: {
      "placeholder": _vm.cardNumberPlaceholder == 'Movie Card Number' ? 'Movie Card Number' : 'Voucher Number'
    },
    model: {
      value: (_vm.newCard.MemberCard),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "MemberCard", $$v)
      },
      expression: "newCard.MemberCard"
    }
  }), _vm._v(" "), _c('sk-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "First Name",
      "placeholder": "Enter a Name"
    },
    model: {
      value: (_vm.newCard.Name),
      callback: function($$v) {
        _vm.$set(_vm.newCard, "Name", $$v)
      },
      expression: "newCard.Name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.validating) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_vm._v("\n                                Almost there! We're validating your card.\n                            ")])], 1)] : _c('sk-button', {
    class: _vm.$breakpoints.xs ? 'btn--block' : 'loyalty-card__no-label',
    attrs: {
      "primary": "",
      "disabled": !_vm.newCardSubmittable,
      "type": "submit"
    }
  }, [_vm._v("Add\n                    ")])], 2)] : [(_vm.isStandardPackageTicket) ? _c('div', {
    staticClass: "form-group"
  }, [_c('sk-button', {
    class: _vm.$breakpoints.xs ? 'btn--block' : 'loyalty-card__no-label',
    attrs: {
      "primary": "",
      "disabled": !_vm.isStandardPackageTicket && _vm.newCardSubmittable,
      "type": "submit"
    }
  }, [_vm._v("Add\n                    ")])], 1) : _vm._e()]], 2), _vm._v(" "), (_vm.order.Session.Loyalties.length > 0) ? _c('div', {
    staticClass: "loyalty-cards"
  }, [_vm._l((_vm.order.Session.Loyalties), function(card, index) {
    return _c('sk-layout', {
      key: index,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name",
      class: _vm.rewardSelected ? 'selected' : ''
    }, [_vm._v(_vm._s(card.Description))]), _vm._v(" "), (card.MemberProviderName) ? _c('div', {
      staticClass: "loyalty-card__name"
    }, [_vm._v(_vm._s(card.MemberProviderName))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__number"
    }, [_vm._v(_vm._s(card.CardNumber))]), _vm._v(" "), (_vm.rewards && _vm.rewards.length > 0 && card.CardNumber == _vm.user.CardNumber && _vm.$breakpoints.smDown) ? _c('div', {
      staticClass: "points-selector",
      class: _vm.rewardSelected ? 'redeemed' : ''
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [_c('div', {
        staticClass: "btn-mask points-selector__point",
        on: {
          "click": function($event) {
            _vm.addReward(reward, card)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v(" "), _vm._v("\n                                    " + _vm._s(reward.Description) + "\n                                    ")], 1)])
    })) : _vm._e()] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (false) ? _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [(_vm.rewards && _vm.rewards.length > 0 && card.CardNumber == _vm.user.CardNumber && !_vm.$breakpoints.smDown) ? _c('div', {
      staticClass: "points-selector",
      class: _vm.rewardSelected ? 'redeemed' : ''
    }, [(card.TicketType.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [(reward && reward.badge && reward.badge.title && reward.badge.color && reward.badge.icon) ? [_c('div', {
        staticClass: "btn-mask points-selector__point",
        attrs: {
          "data-track-context": "rewards",
          "data-track-value": reward.badge.title
        },
        on: {
          "click": function($event) {
            _vm.addReward(reward, card)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v("\n                                            " + _vm._s(reward.Description) + "\n                                        ")], 1)] : _vm._e()], 2)
    })) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteCard(card)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)]) : _vm._e()], 1)
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loyalty-cards"
  }, [_vm._l((_vm.addedVoucherTickets), function(ticket) {
    return (_vm.addedVoucherTickets.length > 0) ? _c('sk-layout', {
      key: ticket.Id,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name"
    }, [_vm._v(_vm._s(ticket.Description) + " - Seat: " + _vm._s(ticket.SeatData))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteVistaVoucherTicket(ticket)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)])], 1) : _vm._e()
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.addedLoyaltyTickets), function(ticket) {
    return (_vm.addedLoyaltyTickets.length > 0) ? _c('sk-layout', {
      key: ticket.Id,
      staticClass: "loyalty-card__preview",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm8": "",
        "md6": ""
      }
    }, [_c('div', {
      staticClass: "loyalty-card__reward-name"
    }, [_vm._v(_vm._s(ticket.Description) + " - Seat: " + _vm._s(ticket.SeatData))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "md6": "",
        "text-right": ""
      }
    }, [(_vm.rewards && _vm.rewards.length > 0) ? _c('div', {
      staticClass: "points-selector"
    }, [(ticket.Description.includes('SK Club')) ? [_c('sk-button', {
      staticClass: "points-selector__button",
      attrs: {
        "icon": "",
        "light": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleRewards($event)
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "flame": ""
      }
    }), (_vm.rewardSelected) ? [_vm._v("Redeemed")] : [_vm._v("Use Rewards")]], 2), _vm._v(" "), (_vm.showRewards) ? _c('div', {
      staticClass: "points-selector__menu"
    }, _vm._l((_vm.rewards), function(reward) {
      return _c('div', {
        key: reward.VistaID
      }, [(reward && reward.badge && reward.badge.title && reward.badge.color && reward.badge.icon) ? [_c('div', {
        staticClass: "btn-mask points-selector__point",
        attrs: {
          "data-track-context": "rewards",
          "data-track-value": reward.badge.title
        },
        on: {
          "click": function($event) {
            _vm.toggelReward(reward, ticket)
          }
        }
      }, [_c('sk-badge', {
        attrs: {
          "small": "",
          "no-backface": "",
          "color": reward.badge.color
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('sk-icon', {
        attrs: {
          "icon": reward.badge.icon
        }
      })], 1)], 2), _vm._v("\n                                            " + _vm._s(reward.Description) + "\n                                        ")], 1)] : _vm._e()], 2)
    })) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "loyalty-card__btn-delete"
    }, [_c('sk-button', {
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteVistaLoyaltyTicket(ticket)
        }
      }
    }, [_vm._v("\n                            Delete\n                        ")])], 1)])], 1) : _vm._e()
  })], 2)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543a4954","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/loyalty/loyalty.vue
// module id = 746
// module chunks = 0